
export const NairaUnit=(val)=>{
  if(!val) return;
  return new Intl.NumberFormat('en-NG', {style:'currency', currency:'NGN'})
  .format(val);
}